// @ts-nocheck
/* eslint-disable */
export const boldLocationIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13.747 5.634c-.7-3.08-3.387-4.467-5.747-4.467h-.007c-2.353 0-5.046 1.38-5.746 4.46-.78 3.44 1.326 6.353 3.233 8.187A3.62 3.62 0 0 0 8 14.834c.907 0 1.813-.34 2.513-1.02 1.907-1.834 4.014-4.74 3.234-8.18M8 8.974a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2"/></svg>`,
    name: 'bold-location' as const
};